import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { nullable } from '@infl-ts/util-io-ts';
import { makeExtendedDecodedQuery, makeLazyDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import { challengeFragment } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
import { ChallengeList } from './codecs';
export var useUnlockedAndSuggestedChallenges = makeExtendedDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query unlockedAndSuggestedChallenges($challengeId: ID!, $unlockedFirst: Int) {\n      suggestedChallenges(first: 3, challengeId: $challengeId) {\n        ...ChallengeFragment\n      }\n      unlockedChallenges(first: $unlockedFirst, completedChallengeId: $challengeId) {\n        ...ChallengeFragment\n      }\n    }\n\n    ", "\n  "])), challengeFragment), t.type({
  suggestedChallenges: nullable(ChallengeList),
  unlockedChallenges: nullable(ChallengeList)
}), t.intersection([t.type({
  challengeId: t.string
}), t.partial({
  unlockedFirst: t.number
})]));
export var useLazyUnlockedAndSuggestedChallenges = makeLazyDecodedQuery(useUnlockedAndSuggestedChallenges.document, useUnlockedAndSuggestedChallenges.output, useUnlockedAndSuggestedChallenges.input);